// Las fechas de sesión sin zona explícita se interpretan como UTC, igual que en el backend.
const parseSessionDate = (value: string | Date): Date => {
  if (value instanceof Date) return value;

  const normalizedValue = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(value)
    ? value
    : `${value}Z`;
  return new Date(normalizedValue);
};

// Agrupa sesiones por el día de la zona seleccionada, no por la fecha UTC.
export const sessionDateKey = (
  value: string | Date,
  timeZone?: string
): string => {
  if (!timeZone) return String(value).split('T')[0];

  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(parseSessionDate(value));
  const dateParts = Object.fromEntries(
    parts
      .filter(({ type }) => type !== 'literal')
      .map(({ type, value: partValue }) => [type, partValue])
  );

  return `${dateParts['year']}-${dateParts['month']}-${dateParts['day']}`;
};

export const formatSessionDate = (
  value: string | Date,
  timeZone: string | undefined,
  options: Intl.DateTimeFormatOptions,
  locale?: string
): string =>
  new Intl.DateTimeFormat(locale, {
    ...options,
    ...(timeZone ? { timeZone } : {}),
  }).format(parseSessionDate(value));
